/* eslint-disable import/prefer-default-export */
import { func, node, string } from "prop-types";

const EllipsisButton = ({ children, onClick, className }) => (
  <button
    type="button"
    className={`tw-bg-white tw-border-none hover:tw-bg-gray-5 active:tw-bg-gray-10 tw-p-[12px] tw-text-start ${className}`}
    onClick={onClick}
  >
    {children}
  </button>
);

EllipsisButton.propTypes = {
  children: node.isRequired,
  onClick: func.isRequired,
  className: string,
};

EllipsisButton.defaultProps = {
  className: "",
}

export default EllipsisButton;